export default {
  install(Vue) {
    Vue.prototype.$ObjValidate = (cb) => {
      try {
        return cb();
      } catch (e) {
        return false;
      }
    }
  }
}
